import classes from "./style.module.scss"

const Ripple = () => {
    return (
        <div className={classes.ripple}><div></div><div></div></div>
    )
}

export default Ripple